module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Invoice":"Rechnung","Total amount":"Gesamtbetrag","Payment Method":"Zahlungsmethode"}}')
  delete Component.options._Ctor
}
